(function () {
    'use strict';

    angular
        .module('elogbooks')
        .controller('SsoLinkPasswordController', SsoLinkPasswordController);

    SsoLinkPasswordController.$inject = [
        '$state',
        '$rootScope',
        '$window',
        '$timeout',
        'rootResource',
        'apiClient',
        'Auth0Service'
    ];

    function SsoLinkPasswordController($state, $rootScope, $window, $timeout, rootResource, apiClient, Auth0Service) {
        $rootScope.skipDirtyCheck = true;

        var vm = this;
        vm.username = $window.localStorage.getItem('ssoUsername');
        vm.password = null;
        vm.errorMessage = null;
        vm.locked = false;
        vm.loading = false;
        vm.forgotPassword = false;
        vm.passwordRequestSubmitted = false;

        vm.themePrefix = rootResource?.theme ?? 'cafm';
        vm.themeLogo = '/' + vm.themePrefix + '-logo.png';
        vm.themeFormerlyLogo = '/' + vm.themePrefix + '-formerly-logo.png';
        vm.helpdeskPhoneNumber = rootResource ? rootResource.helpdeskPhoneNumber : null;

        vm.submit = submit;
        vm.cancel = cancel;
        vm.toggleForgotPassword = toggleForgotPassword;
        vm.forgottenPassword = forgottenPassword;

        var credentials = null;

        // Rebuild Auth0 credentials from the cached session (survives refresh).
        Auth0Service.getSessionCredentials().then(function (creds) {
            if (!creds || !vm.username) {
                returnToStep1();
                return;
            }
            credentials = creds;
        }).catch(function () {
            returnToStep1();
        });

        function submit() {
            if (vm.locked || vm.loading || !credentials || !vm.password) {
                return;
            }

            vm.loading = true;
            vm.errorMessage = null;

            Auth0Service.performSsoLogin(
                credentials.user,
                credentials.jwtToken,
                vm.username,
                vm.password
            ).then(function (response) {
                $window.localStorage.removeItem('ssoUsername');
                return Auth0Service.handleLoginResult(response);
            }).catch(function (error) {
                // performSsoLogin/handleLoginResult are native async functions, so
                // this callback runs outside AngularJS's digest. Bounce back in via
                // $timeout so the error message and field changes render.
                $timeout(function () {
                    handleSubmitError(error);
                });
            });
        }

        // Maps backend /sso/login error codes to the message the user sees on
        // THIS screen. Backend codes are a deliberately uniform, reason-free
        // contract (e.g. SSO_LOGIN_FAILED covers blank/wrong password AND every
        // identity-check failure).
        function handleSubmitError(error) {
            vm.loading = false;

            var message = (error && error.message) ? error.message : error;

            if (message === 'USER_AUTH_TOO_MANY_ATTEMPTS') {
                vm.password = null;
                vm.locked = true;
                vm.errorMessage = 'SSO_LINK_TOO_MANY_ATTEMPTS';
            } else if (message === 'SSO_EMAIL_NOT_UNIQUE') {
                // Rare defensive case. The backend only runs this primary-email
                // uniqueness check AFTER the password is verified correct, so
                // reaching here means the password was RIGHT — the field is
                // cleared only because retrying can't help, not because it was
                // wrong. It's rare because /sso/next-hint already gates on the
                // same uniqueness condition at step 1 (a non-unique email is
                // routed to password login, never SSO); hitting it here needs
                // the email to become non-unique in the window between next-hint
                // and /sso/login. Show the specific, actionable message rather
                // than the generic system error.
                vm.password = null;
                vm.errorMessage = 'SSO_EMAIL_NOT_UNIQUE';
            } else if (message === 'SSO_CANNOT_LINK_ACCOUNT') {
                // The password was not the problem: the backend rejected the LINK
                // itself (no matching account, email/domain mismatch, or already
                // linked). Retrying the password can't help, so clear the field
                // (which also disables submit) rather than implying a credential
                // typo — the "try again" the message invites is the cancel link
                // back to step 1, where the Microsoft account picker is shown.
                // The wording names the email mismatch (the dominant case) but is
                // identical for every sub-case, so it still doesn't disclose which
                // identity check failed.
                vm.password = null;
                vm.errorMessage = 'SSO_CANNOT_LINK_ACCOUNT';
            } else if (message === 'SSO_LOGIN_FAILED') {
                // Wrong/blank password only. A 400 from /sso/login carries
                // { message: 'SSO_LOGIN_FAILED' }. Cleared to match the standard
                // password page's behaviour, so the red validation is visible.
                // Link/identity rejections come back as SSO_CANNOT_LINK_ACCOUNT
                // (handled above), not this code.
                vm.password = null;
                vm.errorMessage = 'INVALID_CREDENTIALS';
            } else {
                // /sso/login succeeded but a later step failed (e.g.
                // INVALID_LOGIN_RESPONSE) — this is NOT a wrong password, so don't
                // clear the field or imply the password was wrong.
                vm.errorMessage = 'SSO_LINK_SYSTEM_ERROR';
            }
        }

        function toggleForgotPassword() {
            vm.errorMessage = null;
            vm.forgotPassword = !vm.forgotPassword;
            vm.passwordRequestSubmitted = false;
        }

        function forgottenPassword() {
            if (vm.loading) {
                return;
            }

            vm.loading = true;

            apiClient.create(rootResource.getLink('passwordchangerequests'), {
                username: vm.username
            }).then(function (response) {
                vm.loading = false;

                if (response) {
                    vm.passwordRequestSubmitted = true;
                }
            });
        }

        function cancel() {
            returnToStep1()
        }

        function returnToStep1() {
            $window.localStorage.removeItem('ssoUsername');
            $window.localStorage.removeItem('ssoDestination');
            $state.go('login.step1');
        }
    }
})();
